import {
  Box,
  Divider,
  List,
  ListItemButton,
  ListItemText,
  Modal,
  Stack,
  TextField,
} from '@mui/material'
import React, { FC } from 'react'
import { Yakureki } from '@/shared/types/yakurekiCore'
import { formatTimeInJPFull } from '@/shared/helpers'

type Props = {
  isOpen: boolean
  searchQuery: string
  setSearchQuery: (searchQuery: string) => void
  onClose: () => void
  select: (id: string) => void
  yakurekiList: Yakureki[]
}

export const SearchModalBody: FC<Props> = ({
  isOpen,
  searchQuery,
  setSearchQuery,
  onClose,
  select,
  yakurekiList,
}) => {
  return (
    <Modal open={isOpen} onClose={onClose} sx={{ zIndex: 1303 }}>
      {/* モーダル全体をラップするコンテナ */}
      <Box
        // モーダル中央寄せ
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',

          // 幅や高さは必要に応じて調整
          width: { xs: '90%', sm: '70%', md: '50%' },
          height: '60vh',

          // 背景やパディング等のスタイル
          bgcolor: 'background.paper',
          borderRadius: '8px',
          boxShadow: 24,
          p: 2,
          display: 'flex',
          flexDirection: 'column', // 縦に積む
        }}
      >
        {/* 上部：検索入力欄 */}
        <TextField
          autoFocus
          fullWidth
          placeholder="ラベルから検索"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          sx={{ mb: 2 }}
        />
        <Box
          sx={{
            flex: 1, // 残りの高さをすべて使う
            overflowY: 'auto', // ここで縦スクロール
          }}
        >
          <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
            {yakurekiList.map((y, index) => (
              <React.Fragment key={y.id}>
                <ListItemButton
                  onClick={() => {
                    select(y.id)
                    onClose()
                  }}
                >
                  <Stack
                    direction="row"
                    spacing={1}
                    justifyContent="space-between"
                    width="100%"
                  >
                    <Box>
                      <ListItemText primary={y.label} />
                    </Box>
                    <Box>
                      <ListItemText
                        primary={formatTimeInJPFull(y.created_at)}
                      />
                    </Box>
                  </Stack>
                </ListItemButton>
                {index < yakurekiList.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </List>
        </Box>
      </Box>
    </Modal>
  )
}
